export default (module, event) => {
  const ev = new CustomEvent(`${module}::${event}`);
  return window.dispatchEvent(ev);
};
